import script from "./ServerFeaturesBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ServerFeaturesBox.vue?vue&type=script&setup=true&lang=js"

import "./ServerFeaturesBox.vue?vue&type=style&index=0&id=f84d53d0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f84d53d0"]])

export default __exports__